/** @format */
import latinize from 'latinize';

/**
 * A helper that will convert a string to ASCII-printable
 */
export function toAsciiPrintable(string: string): string {
    const nonAsciiChars = new RegExp('[^\x20-\x7E]', 'g');
    if ('normalize' in String.prototype) {
        // @see https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
        return string
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(nonAsciiChars, '')
            .trim();
    }

    return latinize(string).replace(nonAsciiChars, '').trim();
}
